// extracted by mini-css-extract-plugin
export default {"section":"Types_section__+IB1K"};